/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Control: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4V7V10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10V8H21C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6H11V4ZM3 16C2.44772 16 2 16.4477 2 17C2 17.5523 2.44772 18 3 18H14C14.5523 18 15 17.5523 15 17C15 16.4477 14.5523 16 14 16H3ZM18 13C18.5523 13 19 13.4477 19 14V16H21C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H19V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V17V14C17 13.4477 17.4477 13 18 13ZM6 8C6.55228 8 7 7.55228 7 7C7 6.44772 6.55228 6 6 6H3C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H6Z'
      fill='currentColor'
    />
  </React.Fragment>
)
